/** @format */

import {  
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import AppSelector from "./pages/AppSelector/AppSelector";
import SignupSelector from "./pages/Signup/SignupSelector";

const App = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<SignupSelector />} />
        <Route path="/privacy" element={<SignupSelector />} />
        <Route path="/terms" element={<SignupSelector />} />
        <Route path="/login" element={<AppSelector />} />
        <Route path="/login/privacy" element={<AppSelector />} />
        <Route path="/login/terms" element={<AppSelector />} />
        <Route path="/signup" element={<SignupSelector />} />
        <Route path="/signup/terms" element={<SignupSelector />} />
        <Route path="/signup/privacy" element={<SignupSelector />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
